<img class="loader" src="assets/images/nrs-loader-v3.svg" alt="Loading" />
